import { render } from "./ClickItem.vue?vue&type=template&id=7519f6b2"
import script from "./ClickItem.vue?vue&type=script&lang=js"
export * from "./ClickItem.vue?vue&type=script&lang=js"

import "./ClickItem.vue?vue&type=style&index=0&id=7519f6b2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__